import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { Form, actions } from 'react-redux-form/immutable'
import { Fieldset, Row, Field } from 'react-gridforms'
import Trash from 'react-icons/lib/md/delete'

import Input from 'components/Input'
import InputCheckbox from 'components/InputCheckbox'
import FieldGroupRow from 'components/FieldGroupRow'

import { required } from 'utils/validators'

const validators = {
  code: { required },
  name: { required },
}
class FormPS extends Component {

  componentDidMount() {
    const { item, dispatch } = this.props

    if (item) {
      dispatch(actions.change('paymentschemeState', item))
    } else {
      // reset form
      dispatch(actions.reset('paymentschemeState'))
    }
  }

  render() {
    const {
      item,
      pending,
      onSubmit,
      onDelete,
    } = this.props

    const isEdit = !!item
    const submit = pending ? 'Saving...' : 'Save Payment Scheme'
    const legend = isEdit ? 'Edit Payment Scheme' : 'Add Payment Scheme'

    return (
      <Form
        model="paymentschemeState"
        validators={validators}
        className="grid-form"
        onSubmit={onSubmit}
      >
        <Fieldset legend={legend}>
          <Row>
            <Field span="3">
              <Input
                model=".code"
                label="Code"
                autoFocus
                required
              />
            </Field>
            <Field span="1">
              <InputCheckbox
                label="Active"
                model=".is_active"
              />
            </Field>
          </Row>
          <FieldGroupRow
            model=".name"
            label="Description"
            required
          />
        </Fieldset>
        <fieldset className="modal-footer" disabled={pending}>
          { isEdit &&
            <button onClick={onDelete} type="button" className="btn btn-icon"><Trash /></button> }
          <button type="submit" className="btn btn-info">{submit}</button>
        </fieldset>
      </Form>
    )
  }
}

FormPS.propTypes = {
  item: PropTypes.object,
  pending: PropTypes.bool,
  onSubmit: PropTypes.func,
  onDelete: PropTypes.func,
  dispatch: PropTypes.func,
}

export default connect()(FormPS)



// WEBPACK FOOTER //
// ./src/containers/Manage/PaymentSchemes/form-ps.js